import { Skeleton } from '@/components/ui/skeleton';
import { PendingRegion } from '@/shared/components/PendingRegion';

/**
 * A workflow surface while it loads (spec 079 US2).
 *
 * Used by both the graph and the builder, which is the honest count: they are the same
 * shape — a canvas that fills its region — and giving them one placeholder each would be
 * two copies maintained together forever.
 *
 * A single reserved area rather than mock nodes and edges. A graph's real shape is
 * unknowable while pending — it may have three steps or thirty — so drawing a plausible
 * one would be the placeholder making a claim it cannot support, and the arrival of the
 * real graph would contradict it visibly (FR-015).
 */
export function WorkflowSkeleton({ label }: { label: string }) {
  return (
    <PendingRegion label={label} className="gap-4 p-6 max-md:px-4 max-md:pt-4">
      <Skeleton className="h-6 w-56" />
      <Skeleton className="min-h-64 flex-1" />
    </PendingRegion>
  );
}
